export enum FeatureFlagEnum {
  AddSmartSearchForm = 'AddSmartSearchForm',
  MobileAppRedirect = 'MobileAppRedirect',
}
